import React from 'react';
import '../assets/css/Square.scss';

const Square = ({ index, condition, text }) => {
  return (
    <span key={index} className={'badge badge-primary mr-2 mr-md-2 my-3 square ' + (condition ? 'available' : 'closed')}>
      <h4 className='d-inline-block px-2 py-4 m-0'>
        <strong>{text}</strong>
      </h4>
    </span >
  );
};

export default Square;
